<template>
  <div class="park-display-screen-alarm">
    <div class="portrait-of-enterprises-bg-img-out-box">
      <!--      <div class="portrait-of-enterprises-bg-img-box" v-if="pageModel === '2D'">-->
      <!--        <img src="../../../assets/park_bg/gjzz.jpg" class="portrait-of-enterprises-bg-img" alt v-if="yqCode === 'gjzz'">-->
      <!--        <img src="../../../assets/park_bg/demo.jpg" class="portrait-of-enterprises-bg-img" alt v-else-if="yqCode === 'demo'">-->
      <!--        <img src="../../../assets/park_bg/jxgj1.jpg" class="portrait-of-enterprises-bg-img" alt v-else-if="yqCode === 'jxgj'">-->
      <!--        <img src="../../../assets/park_bg/jxgj1.jpg" class="portrait-of-enterprises-bg-img" alt v-else>-->
      <!--      </div>-->
    </div>

    <div class="park-display-screen-alarm-svg-box">
      <div class="park-display-screen-alarm-top">
        <div class="park-display-screen-alarm-top-time">{{ currentTime }} {{ currentLunarCalendarDate }}</div>

        <div class="park-display-screen-alarm-top-enterprise-name">{{yqName}}报警中心</div>
      </div>

      <div class="park-display-screen-alarm-svg-box-main">
        <div class="portrait-of-enterprises-bg-3d-iframe-box">
          <iframe scrolling="no" class="portrait-of-enterprises-bg-3d-iframe" frameBorder="0" allowTransparency="true" src="http://121.43.42.99:90/build/#/"></iframe>
        </div>

        <!-- 左 -->
        <div class="portrait-of-enterprises-left">
          <transition enter-active-class="animate__animated animate__fadeInLeft" leave-active-class="animate__animated animate__fadeOutLeftBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip">
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">今日报警</span>
                </div>
                <dv-scroll-board :config="callThePoliceTodayRecordConfig" style="flex: 1;"/>
              </div>

              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">机房监测</span>
                </div>
                <div style="flex: 1;display: flex;justify-content: flex-start;overflow-y: auto;flex-wrap: wrap;">
                  <div v-for="item in distributionRoomList" style="width: 25%;cursor: pointer;" @click="parkDisplayScreenAlarmMask = true">
                    <i class="el-icon-damai-ic_peidianfangguanli"></i>
                    <div>{{item.name}}</div>
                  </div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">工单情况</span>
                </div>
                <div class="portrait-of-enterprises-item-liquid-fill-top-line">
                  <div class="portrait-of-enterprises-item-liquid-fill-top-line-item" v-for="item in inspectionTopData">
                    <div class="portrait-of-enterprises-item-liquid-fill-top-line-item-tip">{{ item.name }}</div>
                    <div class="portrait-of-enterprises-item-liquid-fill-top-line-item-num">{{ item.value }}</div>
                  </div>
                </div>
                <div class="portrait-of-enterprises-item-liquid-fill-line">
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="finishOnTimeLiquidFill" :series="finishOnTimeSeries" />
                    <div>派单率</div>
                  </div>
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="kuangXunLiquidFill" :series="kuangXunSeries" />
                    <div>处理率</div>
                  </div>
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="missedInspectionLiquidFill" :series="missedInspectionSeries" />
                    <div>满意度</div>
                  </div>
                  <div class="portrait-of-enterprises-item-liquid-fill-item">
                    <upper-liquid-fill class="portrait-of-enterprises-item-liquid-fill" liquidFillId="breakdownLiquidFill" :series="breakdownSeries" />
                    <div>巡检故障率</div>
                  </div>
                </div>
              </div>

              <div class="portrait-of-enterprises-item">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">值班人员</span>
                </div>
                <dv-scroll-board :config="personnelAccessRecordConfig" style="flex: 1;"/>
              </div>
            </div>
          </transition>
        </div>

<!--        <div class="portrait-of-enterprises-center-top">-->
<!--          <img src="../../../assets/upper/page_center_top_shadow.png" alt="" class="portrait-of-enterprises-center-top-shadow">-->
<!--          <div class="portrait-of-enterprises-center-top-left-decorate"></div>-->
<!--          <div class="portrait-of-enterprises-center-top-decorate-tip">今日概况</div>-->
<!--          <div class="portrait-of-enterprises-center-top-right-decorate"></div>-->
<!--          <div class="portrait-of-enterprises-center-top-data-statistics-item" v-for="item in pageTopData">-->
<!--            <div class="portrait-of-enterprises-center-top-data-statistics-item-name">{{item.name}}</div>-->
<!--            <div class="portrait-of-enterprises-center-top-data-statistics-item-num">-->
<!--              <div class="portrait-of-enterprises-center-top-data-statistics-item-num-info">{{item.num}}</div>-->
<!--              <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-box" v-if="item.dynamic">-->
<!--                <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-1"></div>-->
<!--                <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-2"></div>-->
<!--                <div class="portrait-of-enterprises-center-top-data-statistics-item-dynamic-3"></div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__zoomInDown" leave-active-class="animate__animated animate__zoomOutDown" :duration="{enter:1000,leave:500}">
          <div class="portrait-of-enterprises-center-bottom-line">
            <img src="../../../assets/upper/page_center_bottom_shadow.png" class="portrait-of-enterprises-center-bottom-line-top-img" alt="">
            <div class="portrait-of-enterprises-center-bottom-line-item" v-for="item in page1BottomData">
              <div class="portrait-of-enterprises-center-bottom-line-item-num">{{ item.num}}
                <span class="portrait-of-enterprises-center-bottom-line-item-unit">{{item.unit}}</span>
              </div>
              <div class="portrait-of-enterprises-center-bottom-line-item-tip">{{ item.name }}</div>
            </div>
          </div>
        </transition>

        <!-- 右 -->
        <div class="portrait-of-enterprises-right">
          <!-- 园区概况 -->
          <transition name="el-zoom-in-center" enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRightBig" :duration="{enter:1000,leave:500}">
            <div class="portrait-of-enterprises-right-strip" >
              <div class="portrait-of-enterprises-item-device-type">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">设备运行概况</span>
                </div>
                <div class="portrait-of-enterprises-item-device-statistics-table">
                  <div class="portrait-of-enterprises-item-device-statistics-table-line" v-for="device in deviceStatisticsList">
                    <div class="portrait-of-enterprises-item-device-statistics-table-line-name-line">
                      <div class="portrait-of-enterprises-item-device-statistics-table-line-name-line-left">{{device.deviceName}}</div>
                      <div class="portrait-of-enterprises-item-device-statistics-table-line-name-line-right">
                        在线设备(台)：<span class="portrait-of-enterprises-item-device-statistics-table-line-name-line-right-info">{{device.online}}</span>
                      </div>
                    </div>
                    <div class="portrait-of-enterprises-item-device-statistics-table-line-info">
                      <div class="portrait-of-enterprises-item-device-statistics-table-line-info-left" :style="{width: device.onlineWidth}">{{device.onlineWidth}}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="portrait-of-enterprises-item-car-3">
                <div class="portrait-of-enterprises-item-title">
                  <img src="../../../assets/upper/page_right_title_img.png" class="portrait-of-enterprises-item-title-img" alt="">
                  <span class="portrait-of-enterprises-item-title-info">本月报警分布排行</span>
                </div>
                <div style="padding: 0.1rem 0;flex: 1;display: flex;flex-direction: column;justify-content: space-between;">
                  <div class="portrait-of-enterprises-item-energy-ranking-line" v-for="(item, index) in fireControlConsumptionConfigData">
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-1" v-if="index === 0">01</div>
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-2" v-if="index === 1">02</div>
                    <div class="portrait-of-enterprises-item-energy-ranking-line-icon-3" v-if="index === 2">03</div>

                    <div class="portrait-of-enterprises-item-energy-ranking-line-info">
                      <div class="portrait-of-enterprises-item-energy-ranking-line-info-name">{{item.deviceName}}{{item.alarmType||''}}</div>
                      <div class="portrait-of-enterprises-item-energy-ranking-line-info-electric">
                        <div class="portrait-of-enterprises-item-energy-ranking-line-info-electric-info" :style="{width: item.alarmWidth}">{{item.alarmCount}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </transition>

        </div>
      </div>
    </div>

    <div class="park-display-screen-alarm-mask" v-if="parkDisplayScreenAlarmMask" @click.self="parkDisplayScreenAlarmMask = false">
      <div class="park-display-screen-alarm-mask-main animate__animated animate__zoomIn">
        <div class="park-display-screen-alarm-mask-main-title">配电房环境监测</div>
        <div class="park-display-screen-alarm-mask-main-chart">
          <upper-line lineId="alarmMaskChart" height="100%" :titleShow="false" :xAxis="alarmMaskChartXAxis" :yAxis="alarmMaskChartYAxis" :series="alarmMaskChartSeries" v-if="parkDisplayScreenAlarmMask"/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import Radar from "../../../components/Echarts/Radar/Radar";
import CommonMultiline from "../../../components/Echarts/Multiline/CommonMultiline";
import CommonLineAndBar from "../../../components/Echarts/Multiline/CommonLineAndBar";
import BasicInfo from "../../../components/Basic/BasicInfo/basicInfo";
import CustomizedPie from "../../../components/Echarts/Pie/Pie/CustomizedPie";
import SceneModel from "../../../components/SceneModel/SceneModel";
import CommonMeter from "../../../components/Echarts/Meter/commonMeter";
import CommonRing from "../../../components/Echarts/Pie/Pie/commonRing";
import { api } from "../../api/BigDataScreen";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import UpperHorizontalBar from "../../../components/UpperEcharts/upperHorizontalBar";
import UpperStackingBar from "../../../components/UpperEcharts/upperStackingBar";
import { getLunarCalendarDate } from "../../../tool/tools";
import UpperRing from "../../../components/UpperEcharts/upperRing";
import UpperLine from "../../../components/UpperEcharts/upperLine";
import UpperLiquidFill from "../../../components/UpperEcharts/upperLiquidFill";
import { fabric } from "fabric";
import screenfull from "screenfull";

export default {
  components: {
    UpperLiquidFill,
    UpperLine,
    UpperRing,
    UpperStackingBar,
    UpperHorizontalBar,
    CommonRing,
    CommonMeter,
    SceneModel,
    CustomizedPie,
    BasicInfo,
    CommonLineAndBar,
    CommonMultiline,
    Radar
  },
  name: "park-display-screen-alarm",
  data() {
    return {
      yqName: "",
      yqCode: "",
      currentTime: "",
      currentLunarCalendarDate: "",
      pageModel: '',
      fullScreen: false,

      parkDisplayScreenBottomBasicBigMap: require("../../../assets/park_img.png"),
      commonTitleStyle: {
        color: "#ffffff"
      },

      pageTopData: [
        {code: 'todayHumanTraffic', name: '今日报警次数', num: '0', dynamic: true },
        {code: 'todayCarTraffic', name: '今日消警次数', num: '0', dynamic: true },
        {code: 'enterpriseCount', name: '今日报警未处理', num: '0', dynamic: false },
        {code: 'totalDeviceNumber', name: '今日值班人数', num: '0', dynamic: false },
      ],

      //  —————————————————————————————————————————园区总览页数据—————————————————————————————————————————————



      // 园区总览底部数据
      page1BottomData: [
        {code: "annualOutput", name: "今日报警次数", icon: "el-icon-damai-shuishou", num: "0", unit: "次"},
        {code: "annualTax", name: "今日消警次数", icon: "el-icon-damai-shuishou", num: "0", unit: "次"},
        {code: "perAreaOutput", name: "今日报警未处理", icon: "el-icon-damai-shuishou", num: "0", unit: "次"},
        {code: "perAreaTax", name: "今日值班人数", icon: "el-icon-damai-shuishou", num: "0", unit: "人"}
      ],

      //  —————————————————————————————————————————园区服务页数据—————————————————————————————————————————————

      // 物业工单统计
      propertyWorkOrderChartXAxis: {
        type: "category",
        name: "日期",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: []
      },
      propertyWorkOrderChartYAxis: {
        type: "value",
        name: "单",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        splitLine: {
          show: false
        }
      },
      propertyWorkOrderChartSeries: [],
      propertyWorkOrderTopData: [
        {name: '工单总数', code: 'repairRecordCount', num: 0},
        {name: '处理率', code: 'repairRate', num: 0}
      ],

      // 资产工单情况
      inspectionTopData: [
        { name: "工单数量", value: "0" },
        { name: "未处理工单", value: "0" },
      ],
      finishOnTimeSeries: [],
      kuangXunSeries: [],
      missedInspectionSeries: [],
      breakdownSeries: [],

      // 配电房列表
      distributionRoomList: [
        {name: '配电房1'},
        {name: '配电房2'},
        {name: '配电房3'},
        {name: '配电房4'},
        {name: '配电房5'},
        {name: '配电房6'},
        {name: '配电房7'},
        {name: '配电房8'}
      ],

      // 严选服务使用情况
      valueAddedDataConfig: {
        data: [
          {name: '', value: ''}
        ],
        // colors: ['#fb1313', '#FB4E13', '#FB7F13', '#FBA813', '#FBD013'],
        showValue: true
      },

      //  —————————————————————————————————————————物联感知页数据—————————————————————————————————————————————

      // 设备运行状况
      equipmentOperationStatusColorList: ['#3ADBDD', '#193248'],
      equipmentOperationStatusLegend: {
        show: false,
        itemWidth: 10,
        itemHeight: 5,
        orient: "vertical",
        left: "left",
        textStyle: {
          color: "#ffffff",
          fontSize: 10,
          lineHeight: 7
        }
      },
      equipmentOperationStatusConfig: [],

      deviceManageBoxShowState: false,
      devicePageChoose: "video",
      deviceManageList: [
        { deviceName: "监控设备", type: "video" },
        { deviceName: "液位设备", type: "level" },
        { deviceName: "液压设备", type: "hydraulic" }
      ],

      currentDeviceChooseItem: {},
      currentDeviceNeverConfigList: [],
      currentDeviceAlreadyConfigList: [],

      // 设备统计
      deviceNumData: [
        { name: "设备总数", type: "", num: 0 },
        { name: "正常在线", type: "success", num: 0 }
      ],
      deviceStatisticsList: [],

      // 人员进出情况
      personnelAccessRecordConfig: {
        header: ["姓名", "手机号", "岗位"],
        columnWidth: [120, 150, 120],
        align: ['left', 'left'],
        waitTime: 5000,
        headerHeight: 24,
        headerBGC: "#ffffff00",
        oddRowBGC: "#ffffff00",
        evenRowBGC: "#122C4799",
        data: [
          ['张三1', '13355887791', '消防'],
          ['张三2', '13355887792', '保安'],
          ['张三3', '13355887793', '维修'],
          ['张三4', '13355887794', '消防'],
          ['张三5', '13355887795', '保安'],
          ['张三6', '13355887796', '维修'],
          ['张三7', '13355887797', '消防'],
          ['张三8', '13355887798', '保安'],
        ]
      },


      // 消防设备运行状况
      fireControlEquipmentOperationStatusColorList: ['#3ADBDD', '#193248'],
      fireControlEquipmentOperationStatusLegend: {
        show: false,
        itemWidth: 10,
        itemHeight: 5,
        orient: "vertical",
        left: "left",
        textStyle: {
          color: "#ffffff",
          fontSize: 10,
          lineHeight: 7
        }
      },
      fireControlEquipmentOperationStatusConfig: [],
      // 设备统计
      fireControlDeviceNumData: [
        { name: "设备总数", num: 0 },
        { name: "正常在线", num: 0 }
      ],
      // 今日报警数
      callThePoliceTodayRecordConfig: {
        header: ["报警设备", "报警时间", "报警类别", "操作"],
        columnWidth: [120, 120, 120, 80],
        align: ['left', 'left', 'left'],
        waitTime: 5000,
        headerHeight: 24,
        headerBGC: "#ffffff00",
        oddRowBGC: "#ffffff00",
        evenRowBGC: "#122C4799",
        data: []
      },
      // 消防排行
      fireControlConsumptionConfigData: [],

      // 设备总数
      totalNumber: "0",
      // 设备离线数
      offLineNumber: "0",
      // 消防设备类型
      fireControlDeviceList: [],

      // 设备在线率

      equipmentOnlineRateConfig: {
        value: 66,
        lineDash: [10, 2]
      },

      // 报警数
      totalAlarmNumber: "0",
      // 未消警数
      unDealNumber: "0",
      // 报警记录
      alarmRecordList: [],

      // 消防员列表
      firemanList: [],

      // 报警排名
      alarmRankingConfig: {},

      // 烟感点位信息
      smokePointsList: [
        {
          deviceName: "A座4层楼梯烟感传感器",
          code: "08061",
          x: "964px",
          y: "459px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "A座4层四层烟感传感器",
          code: "08036",
          x: "454px",
          y: "279px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "A座4层四层烟感传感器",
          code: "08038",
          x: "964px",
          y: "299px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "A座4层四层烟感传感器",
          code: "08040",
          x: "654px",
          y: "329px",
          showTip: false,
          state: "1",
          alarm: "0"
        }
      ],
      // 温感点位信息
      temperaturePointsList: [
        {
          deviceName: "a",
          code: "a",
          x: "384px",
          y: "279px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "b",
          code: "b",
          x: "1094px",
          y: "329px",
          showTip: false,
          state: "1",
          alarm: "0"
        },
        {
          deviceName: "c",
          code: "c",
          x: "1074px",
          y: "239px",
          showTip: false,
          state: "1",
          alarm: "0"
        }
      ],
      // 液位点位信息
      levelPointsList: [],
      // 液压点位信息
      hydraulicPointsList: [],
      // 手报点位信息
      handPointsList: [
        {
          deviceName: "A座20层20F手动报警按钮",
          code: "08129",
          x: "1034px",
          y: "429px",
          showTip: false,
          state: "1",
          alarm: "0"
        }
      ],

      parkDisplayScreenAlarmMask: false,
      alarmMaskChartXAxis: {
        type: "category",
        name: "时间",
        nameTextStyle: {
          color: "#ffffff"
        },
        axisLine: {
          lineStyle: {
            color: "#ffffff"
          }
        },
        data: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00']
      },
      alarmMaskChartYAxis: [
        {
          type: "value",
          name: "数值",
          nameTextStyle: {
            color: "#ffffff"
          },
          axisLine: {
            lineStyle: {
              color: "#ffffff"
            }
          },
          splitLine: {
            show: false
          }
        }
      ],
      alarmMaskChartSeries: [
        {
          name: "电压",
          type: "line",
          stack: "电压",
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          barWidth: "40%",
          itemStyle: {
            color: "#00A0E6"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {offset: 0, color: "#00A0E666"},
              {offset: 1, color: "#00A0E611"}
            ])
          },
          data: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3]
        },
        {
          name: "温度",
          type: "line",
          stack: "温度",
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          barWidth: "40%",
          itemStyle: {
            color: "#32C5E9"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {offset: 0, color: "#32C5E966"},
              {offset: 1, color: "#32C5E911"}
            ])
          },
          data: [2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2]
        },
        {
          name: "水浸",
          type: "line",
          stack: "水浸",
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
          sampling: "average",
          barWidth: "40%",
          itemStyle: {
            color: "#29E065"
          },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {offset: 0, color: "#29E06566"},
              {offset: 1, color: "#29E06511"}
            ])
          },
          data: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
        }
      ]
    };
  },
  created() {
    this.yqCode = bus.global.yqCode

    this.getTime();
    this.getCurrentTime();
    this.getYqInfo();
  },
  mounted() {
    this.initWebSocket()

    this.getPropertyWorkOrderChartData()
    this.getFscAlarmOverviewData()
    this.getEquipmentOperationStatusChartData()
  },
  methods: {
    // 获取园区信息
    getYqInfo() {
      this.$axios.post(api.getYqInfo, {})
        .then(res => {
          let data = res.data.data;
          this.yqName = data.yqName
        })
        .catch(errorHandler("查询园区信息失败"));
    },

    // 时间定时器
    getTime() {
      setInterval(() => {
        this.getCurrentTime();
      }, 1000);
    },
    // 获取当前时间
    getCurrentTime() {
      let currentDate = new Date();
      let YYYY = currentDate.getFullYear();
      let MM =
        currentDate.getMonth() + 1 < 10
          ? "0" + (currentDate.getMonth() + 1)
          : currentDate.getMonth() + 1;
      let DD =
        currentDate.getDate() < 10
          ? "0" + currentDate.getDate()
          : currentDate.getDate();
      let hh =
        currentDate.getHours() < 10
          ? "0" + currentDate.getHours()
          : currentDate.getHours();
      let mm =
        currentDate.getMinutes() < 10
          ? "0" + currentDate.getMinutes()
          : currentDate.getMinutes();
      let ss =
        currentDate.getSeconds() < 10
          ? "0" + currentDate.getSeconds()
          : currentDate.getSeconds();
      let ww = currentDate.getDay();
      let weekDay = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
      ];
      this.currentTime = `${hh}:${mm}:${ss} ${YYYY}/${MM}/${DD} ${weekDay[ww]}`;
      this.currentLunarCalendarDate = getLunarCalendarDate();
    },


    // 获取园区物业工单统计
    getPropertyWorkOrderChartData() {
      this.$axios.get(api.getInteractionData, {})
        .then(res => {
          let data = res.data.data;
          let totalPropertyWorkOrderTopDataMaxValue = 0,
            totalPropertyWorkOrderTopDataMaxValueArr = [],
            totalPropertyWorkOrderTopDataMaxValueRounding = ''
          this.propertyWorkOrderTopData.map(v => {
            v.num = data[v.code]
          })
          let repairStatistic = data.repairStatistic || [];
          let xData = [];
          let series = [];
          repairStatistic.map(v => {
            if (totalPropertyWorkOrderTopDataMaxValue < v.workOrderAmount) {
              totalPropertyWorkOrderTopDataMaxValue = v.workOrderAmount
            }
            xData.push(v.time);
            series.push(v.workOrderAmount);
          });
          let len = totalPropertyWorkOrderTopDataMaxValue.toString().length;
          if (len <= 1) {
            totalPropertyWorkOrderTopDataMaxValueRounding = 10
          } else {
            let mult = Math.pow(10, 1);
            totalPropertyWorkOrderTopDataMaxValueRounding = Math.ceil(totalPropertyWorkOrderTopDataMaxValue / mult) * mult
          }
          series.map(v => {
            totalPropertyWorkOrderTopDataMaxValueArr.push(totalPropertyWorkOrderTopDataMaxValueRounding)
          })
          this.propertyWorkOrderChartXAxis = {
            type: "category",
            name: "日期",
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: xData
          };
          this.propertyWorkOrderChartSeries = [
            {
              name: "物业工单统计",
              type: "bar",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: 18,
              // showBackground: true,
              // backgroundStyle: {
              //   borderRadius: [10, 10, 10, 10],
              //   color: '#909090'
              // },
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#08E8A4"},
                  {offset: 1, color: "#02B1FF"}
                ])
              },
              z: 1,
              data: series
            }, {
              // 分隔
              type: "pictorialBar",
              itemStyle: {
                normal:{
                  color:"#061348"
                }
              },
              symbolRepeat: "fixed",
              symbolMargin: 4,
              symbol: "rect",
              symbolClip: true,
              symbolSize: [16, 1],
              symbolPosition: "center",
              symbolOffset: [-2, 0],
              symbolBoundingData: totalPropertyWorkOrderTopDataMaxValue,
              data: series,
              z: 2,
            }, {
              name: "外框",
              type: "bar",
              barGap: "-120%", // 设置外框位置
              data: totalPropertyWorkOrderTopDataMaxValueArr,
              barWidth: 26,
              itemStyle: {
                normal: {
                  color: "transparent", // 填充色
                  barBorderColor: "#1C4B8E", // 边框色
                  barBorderWidth: 1, // 边框宽度
                  // barBorderRadius: 0, //圆角半径
                  label: {
                    // 标签显示位置
                    show: false,
                    position: "top" // insideTop 或者横向的 insideLeft
                  }
                }
              },
              z: 0
            }
          ];
        })
        .catch(errorHandler("获取报修数据失败"));
    },
    // 获取工单数据
    getInspectionChartData() {
      this.$axios.get(api.getInspectData, {})
        .then(res => {
          let data = res.data.data;
          this.parkServicesData[1].num = data.inspectCompleteTaskCount;
          this.inspectionTopData = [
            { name: "工单点数量", value: data.inspectPointCount || 0 },
            { name: "工单任务", value: data.inspectTaskCount || 0 },
            { name: "工单班组", value: data.inspectTeamCount || 0 },
            { name: "工单人员", value: data.inspectPersonCount || 0 }
          ];
          this.finishOnTimeSeries = [
            {
              name: "按时完成率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectTaskCompleteRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#1CCFD1",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#1CCFD1"] // 100% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#1CCFD199"] // 0% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
          this.kuangXunSeries = [
            {
              name: "旷巡率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectTaskWasteRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#56AEF1",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#56AEF1"] // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#56AEF199"] // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
          this.missedInspectionSeries = [
            {
              name: "漏巡率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectTaskOmitRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#D4AF1D",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#D4AF1D"] // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#D4AF1D99"] // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
          this.breakdownSeries = [
            {
              name: "故障率",
              type: "liquidFill",
              radius: "80%",
              data: [data.inspectBadStatusRate.replace("%", "") / 100],
              label: {
                normal: {
                  color: "#945FF8",
                  insideColor: "#fff",
                  textStyle: {
                    fontSize: 12,
                    fontWeight: "bold"
                  }
                }
              },
              color: [
                {
                  type: "linear",
                  x: 0,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 1,
                      color: ["#945FF8"] // 0% 处的颜色
                    },
                    {
                      offset: 0,
                      color: ["#945FF899"] // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              ],
              outline: {
                show: true,
                borderDistance: 0, // 外部轮廓与图表的距离
                itemStyle: {
                  borderColor: "#27e5f1",
                  borderWidth: 0
                }
              },
              backgroundStyle: {
                color: "transparent" // 图表的背景颜色
              }
            }
          ];
        })
        .catch(errorHandler("获取工单数据失败"));
    },


    // 获取设备运行状况
    getEquipmentOperationStatusChartData() {
      this.$axios.get(api.getDeviceData, {})
        .then(res => {
          let data = res.data.data;
          let onlineDeviceCount = +data.onlineDeviceCount;
          let offlineDeviceCount = +data.offlineDeviceCount;
          let deviceStatisticsList = data.devicesStatus || [];
          deviceStatisticsList.map(v => {
            let allNum = v.online + v.offline;
            if (allNum === 0) {
              v.onlineWidth = "100%";
            } else {
              v.onlineWidth = `${((parseInt(v.online) / allNum) * 100).toFixed(2)}%`;
            }
          });
          this.equipmentOperationStatusConfig = [
            {
              name: "",
              type: "pie",
              radius: ["60%", "80%"],
              center: ["50%", "50%"],
              data: [
                { name: "在线", value: onlineDeviceCount },
                { name: "离线", value: offlineDeviceCount }
              ],
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ];
          this.deviceStatisticsList = deviceStatisticsList;
          this.deviceNumData = [
            { name: "设备总数", num: data.totalDeviceCount },
            { name: "正常在线", num: data.onlineDeviceCount }
          ];
        })
        .catch(errorHandler("获取设备信息失败"));
    },

    // 获取门禁出入流量
    getAccessControlChartData() {
      this.$axios.get(api.getPersonTrafficData, {})
        .then(res => {
          let data = res.data.data;
          this.page4BottomData_2.map(v => {
            v.num = data[v.code];
          });
          let accessControlChartXAxisData = [],
            accessControlChartSeriesInData = [],
            accessControlChartSeriesOutData = [],
            ladderControlChartXAxisData = [],
            ladderControlChartSeriesData = [],
            visitorChartXAxisData = [],
            visitorChartSeriesData = [];
          data.guardWeeklyTraffic.map(v => {
            if (v.time) {
              v.time = v.time.slice(5, 19)
            }
            accessControlChartXAxisData.push(v.time);
            accessControlChartSeriesInData.push(v.passInNumber || v.swingCardNumber);
            accessControlChartSeriesOutData.push(v.passOutNumber);
          });
          this.accessControlChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: accessControlChartXAxisData
          };
          this.accessControlChartSeries = [
            {
              name: "进流量",
              type: "line",
              stack: "进流量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#0DFDF2"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#0DFDF266"},
                  {offset: 1, color: "#0DFDF200"}
                ])
              },
              data: accessControlChartSeriesInData
            },
            {
              name: "出流量",
              type: "line",
              stack: "出流量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#40E971"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#40E97166"},
                  {offset: 1, color: "#40E97100"}
                ])
              },
              data: accessControlChartSeriesOutData
            }
          ];

          data.liftWeeklyTraffic.map(v => {
            if (v.date) {
              v.date = v.date.slice(5, 19)
            }
            ladderControlChartXAxisData.push(v.date);
            ladderControlChartSeriesData.push(v.count);
          });
          this.ladderControlChartXAxis = {
            type: "category",
            name: "日期",
            boundaryGap: false,
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: ladderControlChartXAxisData
          };
          this.ladderControlChartSeries = [
            {
              name: "出入流量",
              type: "line",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: "40%",
              itemStyle: {
                color: "#0DFDF2"
              },
              areaStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#0DFDF2"
                  },
                  {
                    offset: 1,
                    color: "#0DFDF200"
                  }
                ])
              },
              data: ladderControlChartSeriesData
            }
          ];

          let totalVisitorChartSeriesMaxValue = 0, totalVisitorChartSeriesMaxValueRounding = '', totalVisitorChartSeriesMaxValueArr = []
          data.visitorWeeklyTraffic.map(v => {
            if (totalVisitorChartSeriesMaxValue < v.count) {
              totalVisitorChartSeriesMaxValue = v.count
            }
            if (v.date) {
              v.date = v.date.slice(5, 19)
            }
            visitorChartXAxisData.push(v.date);
            visitorChartSeriesData.push(v.count);
          });
          let len = totalVisitorChartSeriesMaxValue.toString().length;
          if (len <= 1) {
            totalVisitorChartSeriesMaxValueRounding = 10
          } else {
            let mult = Math.pow(10, 1);
            totalVisitorChartSeriesMaxValueRounding = Math.ceil(totalVisitorChartSeriesMaxValue / mult) * mult
          }
          visitorChartSeriesData.map(v => {
            totalVisitorChartSeriesMaxValueArr.push(totalVisitorChartSeriesMaxValueRounding)
          })
          this.visitorChartXAxis = {
            type: "category",
            name: "日期",
            nameTextStyle: {
              color: "#ffffff"
            },
            axisLine: {
              lineStyle: {
                color: "#ffffff"
              }
            },
            data: visitorChartXAxisData
          };
          this.visitorChartSeries = [
            {
              name: "访客人数",
              type: "bar",
              stack: "总量",
              // areaStyle: {},
              smooth: true,
              symbol: "circle",
              symbolSize: 5,
              sampling: "average",
              barWidth: 18,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: "#08E8A4"},
                  {offset: 1, color: "#02B1FF"}
                ])
              },
              z: 1,
              data: visitorChartSeriesData
            }, {
              // 分隔
              type: "pictorialBar",
              itemStyle: {
                normal:{
                  color:"#061348"
                }
              },
              symbolRepeat: "fixed",
              symbolMargin: 4,
              symbol: "rect",
              symbolClip: true,
              symbolSize: [16, 1],
              symbolPosition: "center",
              symbolOffset: [-2, 0],
              symbolBoundingData: totalVisitorChartSeriesMaxValue,
              data: visitorChartSeriesData,
              z: 2,
            }, {
              name: "外框",
              type: "bar",
              barGap: "-120%", // 设置外框位置
              data: totalVisitorChartSeriesMaxValueArr,
              barWidth: 26,
              itemStyle: {
                normal: {
                  color: "transparent", // 填充色
                  barBorderColor: "#1C4B8E", // 边框色
                  barBorderWidth: 1, // 边框宽度
                  // barBorderRadius: 0, //圆角半径
                  label: {
                    // 标签显示位置
                    show: false,
                    position: "top" // insideTop 或者横向的 insideLeft
                  }
                }
              },
              z: 0
            }
          ];
        })
        .catch(errorHandler("获取设备信息失败"));
    },

    // 消防数据
    getFscAlarmOverviewData() {
      this.$axios.post(api.fscAlarmOverview, {})
        .then(res => {
          let data = res.data.data;
          let totalCount = data.totalCount
          let onlineCount = data.onlineCount
          this.fireControlDeviceNumData = [
            { name: "设备总数", num: totalCount },
            { name: "正常在线", num: onlineCount }
          ]
          this.fireControlEquipmentOperationStatusConfig = [
            {
              name: "",
              type: "pie",
              radius: ["60%", "80%"],
              center: ["50%", "50%"],
              data: [
                { name: "在线", value: onlineCount },
                { name: "离线", value: (parseInt(totalCount) - parseInt(onlineCount)).toFixed(0) }
              ],
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: true,
                  textStyle: {
                    fontSize: "12"
                  }
                }
              },
              labelLine: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
          let todayAlarmRecord = data.todayAlarmRecord || [], callThePoliceTodayRecordConfigData = []
          todayAlarmRecord.map(v => {
            if (v.uploadTime) {
              v.uploadTime = v.uploadTime.slice(11, 19)
            }
            let arr = [v.deviceName, v.uploadTime, v.alarmStatus];
            callThePoliceTodayRecordConfigData.push(arr)
            if (callThePoliceTodayRecordConfigData.length > 5) {
              callThePoliceTodayRecordConfigData.length = 5
            }
          })
          // 假数据
          callThePoliceTodayRecordConfigData = [
            ['一楼门禁', '12:03:29', '人工分闸', '<span style="color:#F99B2A;">消警</span>'],
            ['二楼门禁', '12:03:29', '设备离线', '<span style="color:#F99B2A;">消警</span>'],
            ['三楼门禁', '12:03:29', '烟感报警', '<span style="color:#F99B2A;">消警</span>'],
            ['四楼门禁', '12:03:29', '液位报警', '<span style="color:#F99B2A;">消警</span>'],
            ['五楼门禁', '12:03:29', '液压报警', '<span style="color:#F99B2A;">消警</span>'],
            ['六楼门禁', '12:03:29', '温感报警', '<span style="color:#F99B2A;">消警</span>'],
            ['七楼门禁', '12:03:29', '手动报警', '<span style="color:#F99B2A;">消警</span>'],
            ['八楼门禁', '12:03:29', '火警', '<span style="color:#F99B2A;">消警</span>']
          ]
          let callThePoliceTodayRecordConfig = {
            header: ["报警设备", "报警时间", "报警类别", "操作"],
            columnWidth: [120, 120, 120, 80],
            align: ['left', 'left', 'left'],
            waitTime: 5000,
            headerHeight: 24,
            headerBGC: "#ffffff00",
            oddRowBGC: "#ffffff00",
            evenRowBGC: "#122C4799",
            data: callThePoliceTodayRecordConfigData
          }
          this.callThePoliceTodayRecordConfig = callThePoliceTodayRecordConfig

          // 本月消防报警分布排行
          let alarmMonthRankList = data.alarmMonthRankList || [], fireControlConsumptionConfigData = [], alarmCountMax = '';
          alarmMonthRankList = [
            {deviceName: '一楼门禁', alarmCount: 25, alarmType: '离线'},
            {deviceName: '二楼门禁', alarmCount: 18, alarmType: '离线'},
            {deviceName: '三楼门禁', alarmCount: 12, alarmType: '离线'},
          ]
          if (alarmMonthRankList.length > 3) {
            alarmMonthRankList.length = 3
          }
          alarmMonthRankList.map(v => {
            if (alarmCountMax < v.alarmCount) {
              alarmCountMax = v.alarmCount
            }
            let obj = {
              deviceName: v.deviceName,
              alarmType: v.alarmType,
              alarmWidth: '',
              alarmCount: v.alarmCount
            }
            fireControlConsumptionConfigData.push(obj);
          });
          fireControlConsumptionConfigData.map(v => {
            v.alarmWidth = `${(v.alarmCount / alarmCountMax * 100).toFixed(2)}%`
          })
          this.fireControlConsumptionConfigData = fireControlConsumptionConfigData

        })
        .catch(errorHandler("获取消防数据失败"));
    },

    // 建立长连接
    connection() {
      // 建立连接对象
      this.socket = new SockJS("https://yq.damaiiot.com/stomp"); //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
      // 获取STOMP子协议的客户端对象
      // this.stompClient = Stomp.client('http://118.178.227.11:15674/ws');
      this.stompClient = Stomp.over(this.socket);
      this.stompClient.heartbeat.outgoing = 10000;
      this.stompClient.heartbeat.incoming = 10000;
      // 定义客户端的认证信息,按需求配置
      let headers = {
        login: "admin",
        passcode: "damai0919damaiiot***",
        // additional header
        "client-id": "my-client-id"
      };
      // 向服务器发起websocket连接
      this.stompClient.connect(
        headers,
        frame => {
          let deviceStatusQueue = `/exchange/alarm_device_status_exchange/${bus.global.yqCode}`;
          let alarmOpenRecordQueue = `/exchange/alarm_open_record_exchange/${bus.global.yqCode}`;
          let alarmCloseRecordQueue = `/exchange/alarm_close_record_exchange/${bus.global.yqCode}`;

          this.stompClient.subscribe(deviceStatusQueue, msg => {
            let data = JSON.parse(msg.body);
            console.log(data);
          });
          this.stompClient.subscribe(alarmOpenRecordQueue, msg => {
            let data = JSON.parse(msg.body);
            console.log(data);
            this.getAlarmStatistics();
            this.getMonthAlarmRankList();
          });
          this.stompClient.subscribe(alarmCloseRecordQueue, msg => {
            let data = JSON.parse(msg.body);
            console.log(data);
            this.getAlarmStatistics();
            this.getMonthAlarmRankList();
          });
          // let personRecordQueue = `/amq/queue/person_record_queue`

          // this.stompClient.send('/exchange/car_out_record', headers, JSON.stringify({sender: '666',chatType: '777'}))
        },
        err => {
          // console.log(err)
          this.disconnect();
          this.connection();
        }
      );
    },
    // 断开连接
    disconnect() {
      if (this.stompClient != null) {
        this.stompClient.disconnect();
        console.log("Disconnected");
      }
    },
    initWebSocket() {
      this.connection();
      let self = this;
      // 断开重连机制,尝试发送消息,捕获异常发生时重连
      this.timer = setInterval(() => {
        try {
          // self.stompClient.send("test");
        } catch (err) {
          console.log("断线了: " + err);
          self.connection();
        }
      }, 5000);
    },
  },

  beforeDestroy() {
    this.disconnect();
  },

  watch: {}
};
</script>

<style scoped lang="less">
.park-display-screen-alarm {
  min-width: 1200px;
  min-height: 100%;
  width: 1600px;
  height: 900px;
  flex: 1;
  color: #ffffff;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  position: relative;
  overflow: auto;
  background: url("../../../assets/upper/upper_bg.png") no-repeat;
  background-size: 100% 100%;
  font-family: PingFangSC-Medium, PingFang SC;
  .portrait-of-enterprises-bg-img-out-box {
    width: 100%;
    height: 100%;
    //flex: 1;
    margin: 0 auto;
    position: relative;
    //box-shadow: 0 0 10px 10px rgba(9, 23, 32, .7);
  }
  .portrait-of-enterprises-bg-img-out-box:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    //box-shadow: 300px 150px 100px rgba(9, 23, 32, 1) inset;
  }
  .portrait-of-enterprises-bg-img-box {
    width: 100%;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    //transform: translateY(-50%);
    .portrait-of-enterprises-bg-img {
      width: 1138px;
      height: 840px;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 5px;
      margin: 0 auto;
    }
    .portrait-of-enterprises-bg-img:after {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      //box-shadow: 0 0 3.6rem 3.6rem rgba(9, 23, 32, 1) inset;
    }
  }
  .portrait-of-enterprises-bg-img-box:after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: url("../../../assets/upper/upper_bg_top.png") no-repeat;
    background-size: 100% 100%;
    //box-shadow: -300px -150px 100px rgba(9, 23, 32, 1) inset;
  }
  .park-display-screen-alarm-svg-box {
    width: 100%;
    min-width: 1580px;
    height: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    //transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    z-index: 99;
    .park-display-screen-alarm-svg-box-svg-main {
      width: 1580px;
      height: 756px;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: 0 auto;
      transform: translateY(-50%);
    }
    path {
      opacity: 0;
      cursor: pointer;
    }
    path:hover {
      opacity: 0.8;
    }
    .point-item {
      z-index: 999;
      i {
        cursor: pointer;
      }
      .el-icon-damai-dingweiweizhi {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 38px;
        color: #32cc32;
      }
      .video-tip-item {
        width: 350px;
        height: 300px;
        position: absolute;
        top: 0;
        left: 16px;
        padding: 5px 25px 10px;
        background: url("../../../assets/basic/top_frame.png") no-repeat;
        background-size: 100% 100%;
        z-index: 99999;
        .video-tip-item-close-line {
          display: flex;
          justify-content: flex-end;
          i {
            color: #eeeeee;
          }
        }
        .video-tip-item-iframe {
          width: 300px;
          height: 225px;
          border-radius: 5px;
          overflow: hidden;
        }
        .video-tip-item-bottom {
          flex: 1;
          margin-top: 10px;
          .video-tip-item-bottom-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .video-tip-item-bottom-line-info {
              color: #ffffff;
            }
          }
          .video-tip-item-bottom-no-tip {
            color: #aaaaaa;
          }
        }
      }

      .pulse,
      .pulse-big {
        position: absolute;
        left: -11px;
        top: -15px;
        width: 60px;
        height: 60px;
        border: 2px solid #ff0000;
        background: rgba(255, 0, 0, 1);
        border-radius: 50%;
        z-index: 100;
        opacity: 0;
        cursor: pointer;
      }
      .pulse {
        background: rgba(255, 0, 0, 1) !important;
        -webkit-animation: warn 0.9s ease-out;
        -moz-animation: warn 0.9s ease-out;
        animation: warn 0.9s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ff0000;
      }
      .pulse-big {
        background: rgba(255, 0, 0, 1) !important;
        -webkit-animation: warn1 0.9s ease-out;
        -moz-animation: warn1 0.9s ease-out;
        animation: warn1 0.9s ease-out;
        -webkit-animation-iteration-count: infinite;
        -moz-animation-iteration-count: infinite;
        animation-iteration-count: infinite;
        box-shadow: 1px 1px 30px #ff0000;
      }
    }

    .park-display-screen-alarm-top {
      width: 100%;
      height: 90px;
      padding: 23px 0 23px 0;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      color: #ffffff;
      background: url("../../../assets/upper/upper_page_top.png") no-repeat;
      background-size: 100% 100%;
      //background-position: bottom;
      z-index: 100;
      overflow: hidden;
      font-family: PingFangSC-Medium, PingFang SC;
      position: relative;
      .park-display-screen-alarm-top-time {
        position: absolute;
        top: 10px;
        left: 30px;
        z-index: 101;
        font-size: 13px;
        font-weight: 400;
        line-height: 18px;
      }
      .park-display-screen-alarm-top-enterprise-name {
        width: 404px;
        height: 42px;
        font-size: 30px;
        font-weight: 500;
        line-height: 42px;
        position: relative;
        //top: -24.3px;
      }
      .park-display-screen-alarm-top-nav-left-relative {
        position: relative;
        right: -20px;
      }
      .park-display-screen-alarm-top-nav-left {
        cursor: pointer;
        width: 251px;
        height: 50px;
        color: #bbbbbb;
        font-weight: 400;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_left.png") no-repeat;
        background-size: 100% 100%;
      }
      .park-display-screen-alarm-top-nav-left-current {
        cursor: pointer;
        width: 251px;
        height: 50px;
        font-weight: 500;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_left_current.png")
        no-repeat;
        background-size: 100% 100%;
      }

      .park-display-screen-alarm-top-nav-relative {
        position: relative;
        left: -20px;
      }
      .park-display-screen-alarm-top-nav {
        cursor: pointer;
        width: 251px;
        height: 50px;
        color: #bbbbbb;
        font-weight: 400;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title.png") no-repeat;
        background-size: 100% 100%;
      }
      .park-display-screen-alarm-top-nav-current {
        cursor: pointer;
        width: 251px;
        height: 50px;
        font-weight: 500;
        line-height: 46px;
        font-size: 20px;
        background: url("../../../assets/upper/top_nav_title_current.png") no-repeat;
        background-size: 100% 100%;
      }
    }

    .park-display-screen-alarm-svg-box-main {
      flex: 1;
      // height: 90%;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      position: relative;
      .portrait-of-enterprises-bg-3d-iframe-box {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        margin: 0 auto;
        z-index: 50;
        box-shadow: 0 0 3.6rem 3.6rem rgba(9, 23, 32, 1) inset;
        .portrait-of-enterprises-bg-3d-iframe {
          width: 100%;
          height: 100%;
        }
        .portrait-of-enterprises-bg-3d-iframe-img {
          width: 40px;
          height: 40px;
          position: absolute;
          top: 15px;
          right: 15px;
          z-index: 51;
          cursor: pointer;
        }
      }
      .portrait-of-enterprises-bg-3d-iframe-box2 {
        width: 100%;
        height: 100%;
        transition: ease-in-out 0.2s;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 9999999;
        .portrait-of-enterprises-bg-3d-iframe {
          width: 100%;
          height: 100%;
        }
        .portrait-of-enterprises-bg-3d-iframe-img {
          width: 40px;
          height: 40px;
          position: absolute;
          top: 15px;
          right: 15px;
          z-index: 51;
          cursor: pointer;
        }
      }
      .portrait-of-enterprises-center-top {
        width: 894px;
        height: 72px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 90;
        background: linear-gradient(360deg, rgba(17, 34, 70, 0) 0%, rgba(18, 35, 69, 0.82) 100%);
        background-size: 100% 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .portrait-of-enterprises-center-top-shadow {
          width: 79px;
          height: 12px;
          position: absolute;
          bottom: -6px;
          left: 815px;
          animation: pageCenterTopShadow 20s linear infinite;
        }
        @keyframes pageCenterTopShadow {
          0% {left: 815px;opacity: 0;}
          10% {left: 652px;opacity: 1;}
          40% {left: 163px;opacity: 1;}
          50% {left: 0;opacity: 0;}
          100% {left: 815px;opacity: 0;}
        }
        .portrait-of-enterprises-center-top-left-decorate {
          width: 42px;
          height: 8px;
          background: url("../../../assets/upper/page_center_top_left_decorate.png") no-repeat;
          background-size: 100% 100%;
          margin-left: 13px;
        }
        .portrait-of-enterprises-center-top-decorate-tip {
          width: 96px;
          height: 37px;
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 37px;
          margin: 0 5px;
        }
        .portrait-of-enterprises-center-top-right-decorate {
          width: 42px;
          height: 8px;
          background: url("../../../assets/upper/page_center_top_right_decorate.png") no-repeat;
          background-size: 100% 100%;
          margin-right: 28px;
        }
        .portrait-of-enterprises-center-top-data-statistics-item {
          width: 160px;
          height: 48px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          .portrait-of-enterprises-center-top-data-statistics-item-name {
            height: 21px;
            font-size: 15px;
            font-weight: 500;
            color: #11FDF2;
            line-height: 21px;
          }
          .portrait-of-enterprises-center-top-data-statistics-item-num {
            height: 24px;
            font-size: 20px;
            font-weight: normal;
            color: #FFFFFF;
            line-height: 24px;
            display: flex;
            justify-content: flex-start;
            align-items: baseline;
            .portrait-of-enterprises-center-top-data-statistics-item-num-info {
              font-family: Helvetica-BoldOblique, Helvetica;
              transform: skew(-10deg);
              -webkit-transform: skew(-10deg); /* for Chrome||Safari */
              -ms-transform: skew(-10deg); /* for IE */
              -moz-transform:skew(-10deg);/* for Firefox */
              -o-transform:skew(-10deg);/* for Opera */
            }
            .portrait-of-enterprises-center-top-data-statistics-item-dynamic-box {
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;
              margin-left: 7px;
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-1 {
                width: 3px;
                height: 5px;
                background: #F6D85D;
                margin-right: 3px;
                animation: dynamic1 1s linear infinite alternate;
              }
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-2 {
                width: 3px;
                height: 8px;
                background: #F5AD59;
                margin-right: 3px;
                animation: dynamic2 1s linear infinite alternate;
              }
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-3 {
                width: 3px;
                height: 11px;
                background: #F58956;
                margin-right: 3px;
                animation: dynamic3 1s linear infinite alternate;
              }
              @keyframes dynamic1 {
                0% {height: 5px;}
                50% {height: 14px;}
                100% {height: 5px;}
              }
              @keyframes dynamic2 {
                0% {height: 9.8px;}
                50% {height: 5px;}
                100% {height: 9.8px;}
              }
              @keyframes dynamic3 {
                0% {height: 14px;}
                50% {height: 9.8px;}
                100% {height: 14px;}
              }
            }
          }
        }
      }
      .portrait-of-enterprises-center-bottom-line, .portrait-of-enterprises-center-bottom-line2, .portrait-of-enterprises-center-bottom-line3 {
        width: 967px;
        height: 108px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        z-index: 90;
        background: url("../../../assets/upper/upper_page_bottom.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .portrait-of-enterprises-center-bottom-line-top-img {
          width: 230px;
          height: 34px;
          position: absolute;
          top: -17px;
          left: 0;
          animation: pageCenterBottomShadow 15s linear infinite;
        }
        @keyframes pageCenterBottomShadow {
          0% {left: 0;opacity: 0;}
          13% {left: 132.8px;opacity: 1;}
          53% {left: 531.2px;opacity: 1;}
          67% {left: 664px;opacity: 0;}
          100% {left: 0;opacity: 0;}
        }
        .portrait-of-enterprises-center-bottom-line-item {
          width: 223.5px;
          height: 106px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          color: #cfac6c;
          text-align: center;
          .portrait-of-enterprises-center-bottom-line-item-tip {
            font-size: 16px;
            font-weight: 500;
            color: #11FDF2;
            line-height: 28px;
          }
          .portrait-of-enterprises-center-bottom-line-item-num {
            height: 47px;
            font-size: 28px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 47px;
          }
          .portrait-of-enterprises-center-bottom-line-item-unit {
            font-size: 28px;
          }
        }
      }

      .portrait-of-enterprises-center-bottom-line2 {
        background: url("../../../assets/upper/page_bottom_bg2.png") no-repeat;
        background-size: 100% 100%;
      }

      .portrait-of-enterprises-center-bottom-line3 {
        background: url("../../../assets/upper/page_bottom_bg3.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-center-bottom-line-item {
          width: 50%;
        }
      }

      .portrait-of-enterprises-left-item-device-config {
        width: 200px;
        height: 150px;
        position: absolute;
        top: 0;
        left: -110px;
        z-index: 66;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        /deep/ .el-radio {
          color: #eeeeee;
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: #cfac6c;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          background: #cfac6c;
          border-color: #cfac6c;
        }
        .portrait-of-enterprises-left-item-device-config-fold-btn {
          height: 24px;
          line-height: 24px;
          cursor: pointer;
          background: linear-gradient(#cfac6c99, #cfac6c66);
        }
        .portrait-of-enterprises-left-item-device-config-main {
          flex: 1;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          padding: 10px;
          background: linear-gradient(#cfac6c66, #cfac6c11);
          .portrait-of-enterprises-left-item-device-config-main-item {
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .el-icon-damai-shezhi {
            cursor: pointer;
          }
        }
      }

      .portrait-of-enterprises-left {
        width: 317px;
        height: 100%;
        padding-bottom: 1%;
        display: flex;
        justify-content: flex-start;
        z-index: 90;
        background: url("../../../assets/upper/upper_page_left.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-right-strip {
          width: 75%;
          height: 100%;
          margin-left: 10%;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          flex-direction: column;
          .portrait-of-enterprises-item-liquid-fill-top-line {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            .portrait-of-enterprises-item-liquid-fill-top-line-item {
              width: 48%;
              height: 20px;
              padding: 0 9px;
              margin-bottom: 3px;
              text-align: left;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: url("../../../assets/upper/inspection_title_bg.png") no-repeat;
              background-size: 100% 100%;
              .portrait-of-enterprises-item-liquid-fill-top-line-item-num {
                flex: 1;
                text-align: right;
                font-size: 12px;
                font-weight: bold;
              }
              .portrait-of-enterprises-item-liquid-fill-top-line-item-tip {
                font-size: 12px;
              }
            }
          }
          .portrait-of-enterprises-item-liquid-fill-line {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            .portrait-of-enterprises-item-liquid-fill-item {
              width: 70px;
              height: 100%;
              display: flex;
              justify-content: flex-end;
              flex-direction: column;
              .portrait-of-enterprises-item-liquid-fill {
                width: 60px;
                height: 60px;
                margin: 0 auto;
                background: url("../../../assets/upper/inspection_chart_bg.png") no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          .portrait-of-enterprises-item-equipment-operation-box {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 4px 6px 10px;
            padding: 0 13px 0 18px;
            background: url("../../../assets/upper/equipment_operation_bg.png") no-repeat;
            background-size: 100% 100%;
          }
          .portrait-of-enterprises-item-equipment-operation-ring-box {
            background: url("../../../assets/upper/device_ring_bg.png") no-repeat;
            background-size: 100% auto;
            background-position: center center;
          }
          .portrait-of-enterprises-item-equipment-operation-status-box {
            flex: 1;
            padding: 5px 10px;
            .portrait-of-enterprises-item-equipment-operation-status-box-item {
              height: 50%;
              padding: 5px 0;
              text-align: right;
              .portrait-of-enterprises-item-equipment-operation-status-box-item-name {
                width: fit-content;
                margin-bottom: 8px;
                padding: 3px 7px;
                background: url("../../../assets/upper/device_ring_name_bg.png") no-repeat;
                background-size: 100% 100%;
              }
              .portrait-of-enterprises-item-equipment-operation-status-box-item-num {
                font-size: 18px;
                height: 22px;
                line-height: 22px;
                padding: 0 13px 0 6px;
                background: url("../../../assets/upper/device_ring_num_bg.png") no-repeat;
                background-size: 100% 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .portrait-of-enterprises-item-equipment-operation-status-box-item-num-info {
                  font-weight: 600;
                  color: #FFFFFF;
                  flex: 1;
                  text-align: center;
                }
                .portrait-of-enterprises-item-equipment-operation-status-box-item-unit {
                  font-size: 12px;
                  font-weight: 500;
                  color: #0DCCFD;
                }
              }
            }
          }

          .portrait-of-enterprises-left-nav {
            width: 300px;
            height: 535px;
            padding: 19px 0 42px 0;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            background: url("../../../assets/upper/page_left.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .portrait-of-enterprises-left-nav-img {
              width: 22px;
              height: 146px;
              position: absolute;
              right: -9px;
              top: 0;
              animation: pageLeftShadow 20s linear infinite;
            }
            @keyframes pageLeftShadow {
              0% {top: 0;opacity: 0;}
              10% {top: 70.8px;opacity: 1;}
              40% {top: 283.2px;opacity: 1;}
              50% {top: 354px;opacity: 0;}
              100% {top: 0;opacity: 0;}
            }
            .portrait-of-enterprises-left-item {
              width: 263px;
              height: 89px;
              padding: 7px 0;
              /deep/ .border-box-content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
              }
              .portrait-of-enterprises-left-item-line {
                flex: 1;
                padding: 0 12px 0 15px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                .portrait-of-enterprises-left-item-line-top {
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .portrait-of-enterprises-left-item-line-tip {
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #12f1e8;
                  }
                  .portrait-of-enterprises-left-item-line-left-img {
                    width: 43px;
                    height: 13px;
                    margin-left: 5px;
                  }
                }
                .portrait-of-enterprises-left-item-line-info {
                  //font-family: "UnidreamLED";
                  padding-top: 14px;
                  font-size: 42px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-end;
                  .portrait-of-enterprises-left-item-line-info-unit {
                    height: 28px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-left: 10px;
                  }
                  @media screen and (prefers-color-scheme: dark) {
                    body {
                      color: #59f6fb;
                      background-color: #1c1b1e;
                    }
                  }
                  .digital {
                    position: relative;
                    width: 20.8px;
                    height: 36.8px;
                    margin-left: 5px;
                    background: url("../../../assets/upper/num_bg.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  .digital span {
                    position: absolute;
                    box-sizing: border-box;
                  }
                  .digital .c1,
                  .digital .c2,
                  .digital .c3 {
                    height: 0;
                    width: 20.8px;
                    border-left: 3.2px solid transparent;
                    border-right: 3.2px solid transparent;
                  }
                  .digital .c1 {
                    top: 0;
                    left: 0;
                    border-top: 3.2px solid currentColor;
                  }
                  .digital .c2 {
                    top: 50%;
                    left: 0;
                    margin-top: -2px;
                  }
                  .digital .c2:before,
                  .digital .c2:after {
                    content: "";
                    height: 0;
                    width: 19.2px;
                    border-left: 1.6px solid transparent;
                    border-right: 1.6px solid transparent;
                    box-sizing: border-box;
                  }
                  .digital .c2:before {
                    position: absolute;
                    top: 0;
                    left: -2.4px;
                    border-bottom: 1.6px solid currentColor;
                  }
                  .digital .c2:after {
                    position: absolute;
                    top: 1.6px;
                    left: -2.4px;
                    border-top: 1.6px solid currentColor;
                  }
                  .digital_point .point {
                    left: 0;
                    bottom: 0;
                    width: 6.4px;
                    height: 6.4px;
                    border-radius: 50%;
                    background: currentColor;
                  }
                  .digital .c3 {
                    bottom: 0;
                    left: 0;
                    border-bottom: 4px solid currentColor;
                  }
                  .digital .l1,
                  .digital .l2 {
                    height: 16.8px;
                    width: 0;
                    left: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-left: 3.2px solid currentColor;
                  }
                  .digital .l1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .l2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }
                  .digital .r1,
                  .digital .r2 {
                    height: 16.8px;
                    width: 0;
                    right: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-right: 3.2px solid currentColor;
                  }
                  .digital .r1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .r2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }

                  .digital_1 .c1,
                  .digital_1 .c2,
                  .digital_1 .c3,
                  .digital_1 .l1,
                  .digital_1 .l2,
                  .digital_2 .l1,
                  .digital_2 .r2,
                  .digital_3 .l1,
                  .digital_3 .l2,
                  .digital_4 .c1,
                  .digital_4 .c3,
                  .digital_4 .l2,
                  .digital_5 .l2,
                  .digital_5 .r1,
                  .digital_6 .r1,
                  .digital_7 .c2,
                  .digital_7 .c3,
                  .digital_7 .l1,
                  .digital_7 .l2,
                  .digital_9 .l2,
                  .digital_0 .c2,
                  .digital_point .c1,
                  .digital_point .c2,
                  .digital_point .c3,
                  .digital_point .l1,
                  .digital_point .l2,
                  .digital_point .r1,
                  .digital_point .r2{
                    animation: changeDigital 200ms 0ms 1 ease-in forwards;
                  }

                  @keyframes changeDigital {
                    form {
                      opacity: 1;
                    }
                    to {
                      opacity: 0;
                    }
                  }

                  .clock {
                    display: flex;
                    justify-content: center;
                  }
                }
                @font-face {
                  font-family: "UnidreamLED";
                  src: url("../../../assets/font/UnidreamLED.eot");
                  src: url("../../../assets/font/UnidreamLED.eot?#iefix")
                  format("embedded-opentype"),
                    /***兼容ie6-ie8***/
                  url("../../../assets/font/UnidreamLED.woff")
                  format("woff"),
                  local("UnidreamLED"),
                  url("../../../assets/font/UnidreamLED.woff"); /***默认使用本地的***/
                }
              }
            }
          }
          .portrait-of-enterprises-left-nav2 {
            width: 300px;
            height: 610px;
            padding: 30px 0 42px 0;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            background: url("../../../assets/upper/page_left2.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .portrait-of-enterprises-left-nav-img {
              width: 22px;
              height: 146px;
              position: absolute;
              right: -9px;
              top: 0;
              animation: pageLeftShadow2 20s linear infinite;
            }
            @keyframes pageLeftShadow2 {
              0% {top: 0;opacity: 0;}
              10% {top: 80.7px;opacity: 1;}
              40% {top: 322.9px;opacity: 1;}
              50% {top: 403.6px;opacity: 0;}
              100% {top: 0;opacity: 0;}
            }
            .portrait-of-enterprises-left-item {
              width: 263px;
              height: 100px;
              padding: 7px 0;
              /deep/ .border-box-content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
              }
              .portrait-of-enterprises-left-item-line {
                flex: 1;
                padding: 0 12px 0 15px;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                flex-direction: column;
                .portrait-of-enterprises-left-item-line-top {
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .portrait-of-enterprises-left-item-line-tip {
                    font-size: 20px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #12f1e8;
                  }
                  .portrait-of-enterprises-left-item-line-left-img {
                    width: 43px;
                    height: 13px;
                    margin-left: 5px;
                  }
                }
                .portrait-of-enterprises-left-item-line-info {
                  //font-family: "UnidreamLED";
                  padding-top: 28px;
                  font-size: 42px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: flex-end;
                  .portrait-of-enterprises-left-item-line-info-unit {
                    height: 28px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-left: 10px;
                  }
                  @media screen and (prefers-color-scheme: dark) {
                    body {
                      color: #59f6fb;
                      background-color: #1c1b1e;
                    }
                  }
                  .digital {
                    position: relative;
                    width: 20.8px;
                    height: 36.8px;
                    margin-left: 5px;
                    background: url("../../../assets/upper/num_bg.png") no-repeat;
                    background-size: 100% 100%;
                  }
                  .digital span {
                    position: absolute;
                    box-sizing: border-box;
                  }
                  .digital .c1,
                  .digital .c2,
                  .digital .c3 {
                    height: 0;
                    width: 20.8px;
                    border-left: 3.2px solid transparent;
                    border-right: 3.2px solid transparent;
                  }
                  .digital .c1 {
                    top: 0;
                    left: 0;
                    border-top: 3.2px solid currentColor;
                  }
                  .digital .c2 {
                    top: 50%;
                    left: 0;
                    margin-top: -2px;
                  }
                  .digital .c2:before,
                  .digital .c2:after {
                    content: "";
                    height: 0;
                    width: 19.2px;
                    border-left: 1.6px solid transparent;
                    border-right: 1.6px solid transparent;
                    box-sizing: border-box;
                  }
                  .digital .c2:before {
                    position: absolute;
                    top: 0;
                    left: -2.4px;
                    border-bottom: 1.6px solid currentColor;
                  }
                  .digital .c2:after {
                    position: absolute;
                    top: 1.6px;
                    left: -2.4px;
                    border-top: 1.6px solid currentColor;
                  }
                  .digital_point .point {
                    left: 0;
                    bottom: 0;
                    width: 6.4px;
                    height: 6.4px;
                    border-radius: 50%;
                    background: currentColor;
                  }
                  .digital .c3 {
                    bottom: 0;
                    left: 0;
                    border-bottom: 4px solid currentColor;
                  }
                  .digital .l1,
                  .digital .l2 {
                    height: 16.8px;
                    width: 0;
                    left: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-left: 3.2px solid currentColor;
                  }
                  .digital .l1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .l2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }
                  .digital .r1,
                  .digital .r2 {
                    height: 16.8px;
                    width: 0;
                    right: 0;
                    border-top: 1.6px solid transparent;
                    border-bottom: 1.6px solid transparent;
                    border-right: 3.2px solid currentColor;
                  }
                  .digital .r1 {
                    top: 0.8px;
                    border-top-width: 3.2px;
                  }
                  .digital .r2 {
                    top: 19.2px;
                    border-bottom-width: 3.2px;
                  }

                  .digital_1 .c1,
                  .digital_1 .c2,
                  .digital_1 .c3,
                  .digital_1 .l1,
                  .digital_1 .l2,
                  .digital_2 .l1,
                  .digital_2 .r2,
                  .digital_3 .l1,
                  .digital_3 .l2,
                  .digital_4 .c1,
                  .digital_4 .c3,
                  .digital_4 .l2,
                  .digital_5 .l2,
                  .digital_5 .r1,
                  .digital_6 .r1,
                  .digital_7 .c2,
                  .digital_7 .c3,
                  .digital_7 .l1,
                  .digital_7 .l2,
                  .digital_9 .l2,
                  .digital_0 .c2,
                  .digital_point .c1,
                  .digital_point .c2,
                  .digital_point .c3,
                  .digital_point .l1,
                  .digital_point .l2,
                  .digital_point .r1,
                  .digital_point .r2{
                    animation: changeDigital 200ms 0ms 1 ease-in forwards;
                  }

                  @keyframes changeDigital {
                    form {
                      opacity: 1;
                    }
                    to {
                      opacity: 0;
                    }
                  }

                  .clock {
                    display: flex;
                    justify-content: center;
                  }
                }
                @font-face {
                  font-family: "UnidreamLED";
                  src: url("../../../assets/font/UnidreamLED.eot");
                  src: url("../../../assets/font/UnidreamLED.eot?#iefix")
                  format("embedded-opentype"),
                    /***兼容ie6-ie8***/
                  url("../../../assets/font/UnidreamLED.woff")
                  format("woff"),
                  local("UnidreamLED"),
                  url("../../../assets/font/UnidreamLED.woff"); /***默认使用本地的***/
                }
              }
            }
          }
          .portrait-of-enterprises-left-nav3 {
            width: 300px;
            height: 610px;
            //padding: 30px 0 42px 0;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            background: url("../../../assets/upper/page_left_3.png") no-repeat;
            background-size: 100% 100%;
            position: relative;
            .portrait-of-enterprises-left-nav-img {
              width: 22px;
              height: 146px;
              position: absolute;
              right: -9px;
              top: 0;
              animation: pageLeftShadow2 20s linear infinite;
            }
            @keyframes pageLeftShadow2 {
              0% {top: 0;opacity: 0;}
              10% {top: 80.7px;opacity: 1;}
              40% {top: 322.9px;opacity: 1;}
              50% {top: 403.6px;opacity: 0;}
              100% {top: 0;opacity: 0;}
            }
            .portrait-of-enterprises-left-item {
              width: 230px;
              height: 25%;
              padding: 7px 0;
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              cursor: pointer;
              font-family: PingFangSC-Regular, PingFang SC;
              /deep/ .border-box-content {
                display: flex;
                justify-content: flex-start;
                align-items: center;
              }
              .portrait-of-enterprises-left-item-line, .portrait-of-enterprises-left-item-line-current {
                width: 222px;
                height: 88px;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                background: url("../../../assets/upper/page_left_3_nav.png") no-repeat;
                background-size: 100% 100%;
                position: relative;
                //.portrait-of-enterprises-left-item-line-embellish {
                //  width: 161px;
                //  height: 7px;
                //  position: absolute;
                //  right: 0;
                //  bottom: 20px;
                //}
                .portrait-of-enterprises-left-item-line-left-img-out-box {
                  width: 88px;
                  height: 88px;
                  margin: 0 8px 0 9px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  .portrait-of-enterprises-left-item-line-left-img-4-1 {
                    width: 35px;
                    height: 26px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-2 {
                    width: 31px;
                    height: 31px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-3 {
                    width: 33px;
                    height: 23px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-4 {
                    width: 26px;
                    height: 26px;
                  }
                  .portrait-of-enterprises-left-item-line-left-img-4-5 {
                    width: 26px;
                    height: 31px;
                  }
                }
                .portrait-of-enterprises-left-item-line-tip {
                  flex: 1;
                  height: 24px;
                  font-size: 17px;
                  font-weight: 500;
                  color: #FFFFFF;
                  line-height: 24px;
                  text-align: left;
                }
              }
              .portrait-of-enterprises-left-item-line-current {
                background: url("../../../assets/upper/page_left_3_nav_current.png") no-repeat;
                background-size: 100% 100%;
              }
            }
          }
          .portrait-of-enterprises-left-card {
            width: 300px;
            height: 190px;
            background: url("../../../assets/upper/page_left_bottom.png")
            no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .portrait-of-enterprises-left-card-img {
              width: 220px;
              height: 124px;
            }
          }
          /deep/ .el-carousel__button {
            width: 20px;
          }
        }
      }
      .portrait-of-enterprises-center {
        height: 100%;
        padding-bottom: 1%;
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: column;
        position: relative;

        .portrait-of-enterprises-center-top {
          width: 894px;
          height: 72px;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          margin: 0 auto;
          z-index: 88;
          background: url("../../../assets/upper/page_center_top.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .portrait-of-enterprises-center-top-shadow {
            width: 79px;
            height: 12px;
            position: absolute;
            bottom: -6px;
            left: 815px;
            animation: pageCenterTopShadow 20s linear infinite;
          }
          @keyframes pageCenterTopShadow {
            0% {left: 815px;opacity: 0;}
            10% {left: 652px;opacity: 1;}
            40% {left: 163px;opacity: 1;}
            50% {left: 0;opacity: 0;}
            100% {left: 815px;opacity: 0;}
          }
          .portrait-of-enterprises-center-top-left-decorate {
            width: 42px;
            height: 8px;
            background: url("../../../assets/upper/page_center_top_left_decorate.png") no-repeat;
            background-size: 100% 100%;
            margin-left: 13px;
          }
          .portrait-of-enterprises-center-top-decorate-tip {
            width: 96px;
            height: 37px;
            font-size: 18px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 37px;
            margin: 0 5px;
          }
          .portrait-of-enterprises-center-top-right-decorate {
            width: 42px;
            height: 8px;
            background: url("../../../assets/upper/page_center_top_right_decorate.png") no-repeat;
            background-size: 100% 100%;
            margin-right: 28px;
          }
          .portrait-of-enterprises-center-top-data-statistics-item {
            width: 96px;
            height: 48px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            align-items: flex-start;
            text-align: left;
            .portrait-of-enterprises-center-top-data-statistics-item-name {
              height: 21px;
              font-size: 15px;
              font-weight: 500;
              color: #11FDF2;
              line-height: 21px;
            }
            .portrait-of-enterprises-center-top-data-statistics-item-num {
              height: 24px;
              font-size: 20px;
              font-weight: normal;
              color: #FFFFFF;
              line-height: 24px;
              display: flex;
              justify-content: flex-start;
              align-items: baseline;
              .portrait-of-enterprises-center-top-data-statistics-item-num-info {
                font-family: Helvetica-BoldOblique, Helvetica;
                transform: skew(-10deg);
                -webkit-transform: skew(-10deg); /* for Chrome||Safari */
                -ms-transform: skew(-10deg); /* for IE */
                -moz-transform:skew(-10deg);/* for Firefox */
                -o-transform:skew(-10deg);/* for Opera */
              }
              .portrait-of-enterprises-center-top-data-statistics-item-dynamic-box {
                display: flex;
                justify-content: flex-start;
                align-items: flex-end;
                margin-left: 7px;
                .portrait-of-enterprises-center-top-data-statistics-item-dynamic-1 {
                  width: 3px;
                  height: 5px;
                  background: #F6D85D;
                  margin-right: 3px;
                  animation: dynamic1 1s linear infinite alternate;
                }
                .portrait-of-enterprises-center-top-data-statistics-item-dynamic-2 {
                  width: 3px;
                  height: 8px;
                  background: #F5AD59;
                  margin-right: 3px;
                  animation: dynamic2 1s linear infinite alternate;
                }
                .portrait-of-enterprises-center-top-data-statistics-item-dynamic-3 {
                  width: 3px;
                  height: 11px;
                  background: #F58956;
                  margin-right: 3px;
                  animation: dynamic3 1s linear infinite alternate;
                }
                @keyframes dynamic1 {
                  0% {height: 5px;}
                  50% {height: 14px;}
                  100% {height: 5px;}
                }
                @keyframes dynamic2 {
                  0% {height: 9.8px;}
                  50% {height: 5px;}
                  100% {height: 9.8px;}
                }
                @keyframes dynamic3 {
                  0% {height: 14px;}
                  50% {height: 9.8px;}
                  100% {height: 14px;}
                }
              }
            }
          }
        }
        .portrait-of-enterprises-center-bottom-line, .portrait-of-enterprises-center-bottom-line2, .portrait-of-enterprises-center-bottom-line3 {
          width: 894px;
          height: 106px;
          background: url("../../../assets/upper/page_bottom_bg.png") no-repeat;
          background-size: 100% 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: relative;
          .portrait-of-enterprises-center-bottom-line-top-img {
            width: 230px;
            height: 34px;
            position: absolute;
            top: -17px;
            left: 0;
            animation: pageCenterBottomShadow 15s linear infinite;
          }
          @keyframes pageCenterBottomShadow {
            0% {left: 0;opacity: 0;}
            13% {left: 132.8px;opacity: 1;}
            53% {left: 531.2px;opacity: 1;}
            67% {left: 664px;opacity: 0;}
            100% {left: 0;opacity: 0;}
          }
          .portrait-of-enterprises-center-bottom-line-item {
            width: 223.5px;
            height: 106px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            color: #cfac6c;
            text-align: center;
            .portrait-of-enterprises-center-bottom-line-item-tip {
              font-size: 16px;
              font-weight: 500;
              color: #11FDF2;
              line-height: 28px;
            }
            .portrait-of-enterprises-center-bottom-line-item-num {
              height: 47px;
              font-size: 28px;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 47px;
            }
            .portrait-of-enterprises-center-bottom-line-item-unit {
              font-size: 28px;
            }
          }
        }

        .portrait-of-enterprises-center-bottom-line2 {
          background: url("../../../assets/upper/page_bottom_bg2.png") no-repeat;
          background-size: 100% 100%;
        }

        .portrait-of-enterprises-center-bottom-line3 {
          background: url("../../../assets/upper/page_bottom_bg3.png") no-repeat;
          background-size: 100% 100%;
          .portrait-of-enterprises-center-bottom-line-item {
            width: 50%;
          }
        }

        .portrait-of-enterprises-left-item-device-config {
          width: 200px;
          height: 150px;
          position: absolute;
          top: 0;
          left: -110px;
          z-index: 66;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          /deep/ .el-radio {
            color: #eeeeee;
          }
          /deep/ .el-radio__input.is-checked + .el-radio__label {
            color: #cfac6c;
          }
          /deep/ .el-radio__input.is-checked .el-radio__inner {
            background: #cfac6c;
            border-color: #cfac6c;
          }
          .portrait-of-enterprises-left-item-device-config-fold-btn {
            height: 24px;
            line-height: 24px;
            cursor: pointer;
            background: linear-gradient(#cfac6c99, #cfac6c66);
          }
          .portrait-of-enterprises-left-item-device-config-main {
            flex: 1;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            padding: 10px;
            background: linear-gradient(#cfac6c66, #cfac6c11);
            .portrait-of-enterprises-left-item-device-config-main-item {
              padding: 10px;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .el-icon-damai-shezhi {
              cursor: pointer;
            }
          }
        }
      }
      .portrait-of-enterprises-right {
        width: 317px;
        height: 100%;
        padding-bottom: 1%;
        display: flex;
        justify-content: flex-start;
        z-index: 90;
        background: url("../../../assets/upper/upper_page_right.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-right-strip {
          height: 100%;
          display: flex;
          justify-content: space-between;
          flex-direction: column;


          .portrait-of-enterprises-item-device-statistics-table {
            width: 100%;
            padding: 10px 10px;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: column;
            .portrait-of-enterprises-item-device-statistics-table-line {
              width: 100%;
              .portrait-of-enterprises-item-device-statistics-table-line-name-line {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 3px;
                .portrait-of-enterprises-item-device-statistics-table-line-name-line-left {
                  font-size: 12px;
                  text-align: center;
                  padding: 2px 10px;
                  background: url("../../../assets/upper/device_proportion_name_bg.png") no-repeat;
                  background-size: 100% 100%;
                }
                .portrait-of-enterprises-item-device-statistics-table-line-name-line-right {
                  .portrait-of-enterprises-item-device-statistics-table-line-name-line-right-info {
                    font-weight: 500;
                    font-family: fantasy;
                    font-size: 16px;
                  }
                }
              }
              .portrait-of-enterprises-item-device-statistics-table-line-info {
                height: 14px;
                line-height: 14px;
                overflow: hidden;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                background: url("../../../assets/upper/device_proportion_bg.png") no-repeat;
                background-size: 100% 100%;
                .portrait-of-enterprises-item-device-statistics-table-line-info-left {
                  text-align: right;
                  font-size: 12px;
                  font-weight: 600;
                  color: #000000;
                  line-height: 12px;
                  background: linear-gradient(270deg, #08E8A4 0%, rgba(2, 177, 255, 0) 100%);
                }
              }
            }
          }

          .portrait-of-enterprises-right-in-and-out-snapshot {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0 0 0;
            background: url("../../../assets/upper/page_right_item_car_division.png") no-repeat;
            background-position: center center;
            background-size: auto 100%;
            .portrait-of-enterprises-right-in-and-out-snapshot-item {
              width: 48%;
              height: 100%;
              padding: 0 0 20px 0;
              display: flex;
              justify-content: space-between;
              flex-direction: column;
              align-items: center;
              text-align: center;
              font-family: PingFangSC-Medium, PingFang SC;
              .portrait-of-enterprises-right-in-and-out-snapshot-item-top-title {
                width: 80px;
                height: 14px;
                margin: 0 auto;
                font-size: 10px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 14px;
              }
              .portrait-of-enterprises-right-in-and-out-snapshot-item-img-out-box {
                width: 100px;
                height: 50px;
                margin: 0 auto;
                background: url("../../../assets/upper/page_right_item_car_number_bg.png") no-repeat;
                background-size: 100% 100%;
                .portrait-of-enterprises-right-in-and-out-snapshot-item-img {
                  width: 94px;
                  height: 46px;
                  margin: 3px auto;
                }
              }
              .portrait-of-enterprises-right-in-and-out-snapshot-item-tip {
                width: 80px;
                font-size: 10px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 14px;
                text-align: left;
                margin: 0 auto;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .portrait-of-enterprises-right-in-and-out-snapshot-item-spot {
                  width: 6px;
                  height: 6px;
                  margin: 4px 4px 4px 0;
                  border-radius: 50%;
                  background: #12FDF0;
                  display: inline-block;
                }
                .portrait-of-enterprises-right-in-and-out-snapshot-item-tip-text {
                  flex: 1;
                }
              }
            }
          }

          .portrait-of-enterprises-item-energy-distribution-box {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .portrait-of-enterprises-item-energy-distribution-ring-box {
              background: url("../../../assets/upper/device_ring_bg.png") no-repeat;
              background-size: 100% auto;
              background-position: center center;
            }
          }

          .portrait-of-enterprises-item-energy-ranking-line {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 0 10px;
            margin-bottom: 8px;
            .portrait-of-enterprises-item-energy-ranking-line-icon-1, .portrait-of-enterprises-item-energy-ranking-line-icon-2, .portrait-of-enterprises-item-energy-ranking-line-icon-3 {
              width: 26px;
              height: 14px;
              line-height: 14px;
              font-size: 12px;
              font-weight: 500;
              margin: 6px 20px 0 0;
            }
            .portrait-of-enterprises-item-energy-ranking-line-icon-1 {
              background: url("../../../assets/upper/energy_ranking_1.png") no-repeat;
              background-size: 100% 100%;
            }
            .portrait-of-enterprises-item-energy-ranking-line-icon-2 {
              background: url("../../../assets/upper/energy_ranking_2.png") no-repeat;
              background-size: 100% 100%;
            }
            .portrait-of-enterprises-item-energy-ranking-line-icon-3 {
              background: url("../../../assets/upper/energy_ranking_3.png") no-repeat;
              background-size: 100% 100%;
            }
            .portrait-of-enterprises-item-energy-ranking-line-info {
              flex: 1;
              font-size: 12px;
              .portrait-of-enterprises-item-energy-ranking-line-info-name {
                text-align: left;
                line-height: 14px;
                margin-bottom: 2px;
              }
              .portrait-of-enterprises-item-energy-ranking-line-info-electric {
                height: 10px;
                line-height: 10px;
                text-align: right;
                background: url("../../../assets/upper/device_ring_num_bg.png") no-repeat;
                background-size: 100% 100%;
                margin-bottom: 2px;
                .portrait-of-enterprises-item-energy-ranking-line-info-electric-info {
                  white-space: nowrap;
                  height: 12px;
                  font-size: 10px;
                  font-weight: 600;
                  color: #000000;
                  line-height: 12px;
                  background: linear-gradient(270deg, #08E8A4 0%, rgba(2, 177, 255, 0) 100%);
                }
              }
              .portrait-of-enterprises-item-energy-ranking-line-info-water {
                height: 10px;
                line-height: 10px;
                text-align: right;
                background: url("../../../assets/upper/device_ring_num_bg.png") no-repeat;
                background-size: 100% 100%;
                .portrait-of-enterprises-item-energy-ranking-line-info-water-info {
                  white-space: nowrap;
                  height: 12px;
                  font-size: 10px;
                  font-weight: 600;
                  color: #000000;
                  line-height: 12px;
                  background: linear-gradient(270deg, #E8E708 0%, rgba(244, 206, 89, 0) 100%);
                }
              }
            }
          }
          .portrait-of-enterprises-item-energy-ranking-line:last-child {
            margin-bottom: 0;
          }
        }
      }

      .portrait-of-enterprises-item, .portrait-of-enterprises-item-2, .portrait-of-enterprises-item-car-1, .portrait-of-enterprises-item-car-2, .portrait-of-enterprises-item-car-3, .portrait-of-enterprises-item-device-top, .portrait-of-enterprises-item-device-type {
        width: 306.67px;
        height: 185.83px;
        padding: 10px 20px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        background: url("../../../assets/upper/page_right_item_bg.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-item-title {
          margin: 5px 0 5px 0;
          color: #ffffff;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .portrait-of-enterprises-item-title-icon {
            width: 32px;
            font-size: 18px;
            padding: 0 0 5px 0;
          }
          .portrait-of-enterprises-item-title-info {
            padding: 0 0 5px 0;
            font-size: 14px;
            margin-left: 5px;
          }
        }
        .portrait-of-enterprises-item-ring-box {
          flex: 1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .portrait-of-enterprises-item-ring-box-left {
            width: 90px;
            height: 90px;
            background: url("../../../assets/upper/ring_bg.png") no-repeat;
            background-size: 100%;
            background-position-y: center;
          }
          .portrait-of-enterprises-item-ring-box-right {
            height: 116px;
            flex: 1;
            overflow-y: auto;
            .portrait-of-enterprises-item-ring-box-right-line {
              width: 150px;
              height: 22px;
              margin: 0 auto 7px;
              padding: 0 3px 0 8px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: url("../../../assets/upper/ring_legend_bg.png") no-repeat;
              background-size: 100% 100%;
              .portrait-of-enterprises-item-ring-box-right-line-color {
                width: 9px;
                height: 8px;
              }
              .portrait-of-enterprises-item-ring-box-right-line-name {
                flex: 1;
                font-size: 10px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 13px;
                margin: 0 3px;
                text-align: left;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .portrait-of-enterprises-item-ring-box-right-line-num {
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 15px;
              }
              .portrait-of-enterprises-item-ring-box-right-line-proportion {
                font-size: 12px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 15px;
              }
            }
          }
        }
        .total-intellectual-property-config-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          .total-intellectual-property-config-line-name {
            width: 64px;
            height: 14px;
            padding: 0 4px;
            line-height: 14px;
            font-size: 8px;
            background: url("../../../assets/upper/total_intellectual_name_bg.png") no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
          .total-intellectual-property-config-line-value {
            flex: 1;
            width: 139px;
            height: 12px;
            margin-left: 6px;
            background: url("../../../assets/upper/total_intellectual_value_bg.png") no-repeat;
            background-size: 100% 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .total-intellectual-property-config-line-value-info {
              color: #000000;
              text-align: right;
              font-weight: 600;
              font-size: 8px;
              line-height: 12px;
              background: linear-gradient(270deg, #08E8A4 0%, rgba(2, 177, 255, 0) 100%);
            }
          }
        }
        /deep/ .el-timeline-item__content {
          font-size: 12px;
        }
        /deep/ .el-timeline-item__timestamp {
          font-size: 12px;
        }
        /deep/ .el-timeline-item__tail {
          left: 0;
          top: 12%;
          width: 1px;
          height: 80%;
          background: #0DFDF2;
          border: 0;
        }
        /deep/ .el-timeline-item__node--normal {
          width: 3px;
          height: 3px;
          background: #0DFDF2;
          box-shadow: 0px 0px 3px 0px rgba(125,224,195,0.5);
        }
        /deep/ .active-ring-chart-container canvas {
          width: 100%;
          height: 100%;
        }
        /deep/ .dv-active-ring-chart .active-ring-info .dv-digital-flop {
          width: 70px;
          height: 24px;
        }
        /deep/ .dv-active-ring-chart .active-ring-info .active-ring-name {
          width: 70px;
          white-space: normal;
        }
        /deep/ .dv-capsule-chart .label-column div {
          width: 100px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        /deep/ .dv-scroll-board .header .header-item {
          font-size: 12px;
        }
        /deep/ .dv-scroll-board .rows .row-item {
          font-size: 12px;
          height: 21.6px;
          line-height: 21.6px;
        }
        /deep/ .dv-scroll-board .rows {
          height: 108px;
        }
      }
      .portrait-of-enterprises-item-2 {
        width: 306.67px;
        height: 196px;
        background: url("../../../assets/upper/page_right_item_bg2.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-car-1 {
        width: 306.67px;
        height: 271.69px;
        background: url("../../../assets/upper/car_page_right_item_bg.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-car-2 {
        width: 306.67px;
        height: 235.54px;
        background: url("../../../assets/upper/car_page_right_item_bg_2.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-car-3 {
        width: 306.67px;
        height: 223.06px;
        background: url("../../../assets/upper/car_page_right_item_bg_3.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-item-car-top-line {
          width: 100%;
          margin: 9px 0;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .portrait-of-enterprises-item-car-top-line-item {
            width: 49%;
            height: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .portrait-of-enterprises-item-car-top-line-item-title {
              font-size: 8px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 11px;
            }
            .portrait-of-enterprises-item-car-top-line-item-num {
              width: auto;
              padding: 0 6px;
              height: 14px;
              line-height: 14px;
              background: #14ABF9;
              background: url("../../../assets/upper/page_right_property_num.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
      .portrait-of-enterprises-item-device-top {
        width: 306.67px;
        height: 219.05px;
        background: url("../../../assets/upper/page_right_item_device_top.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item-device-type {
        width: 306.67px;
        height: 521.61px;
        background: url("../../../assets/upper/page_right_item_device_type.png") no-repeat;
        background-size: 100% 100%;
      }
      .portrait-of-enterprises-item2 {
        width: 306.67px;
        height: 185.83px;
        padding: 10px 20px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        background: url("../../../assets/upper/page_right_item_bg.png") no-repeat;
        background-size: 100% 100%;
        .portrait-of-enterprises-item-property-work-order-line {
          width: 100%;
          margin: 9px 0;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .portrait-of-enterprises-item-property-work-order-line-item {
            width: 49%;
            height: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .portrait-of-enterprises-item-property-work-order-line-item-title {
              font-size: 9px;
              font-weight: 400;
              color: #FFFFFF;
              line-height: 11px;
              margin-right: 6px;
            }
            .portrait-of-enterprises-item-property-work-order-line-item-num {
              width: auto;
              padding: 0 7px;
              height: 14px;
              line-height: 14px;
              background: #14ABF9;
              background: url("../../../assets/upper/page_right_property_num.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .portrait-of-enterprises-item-title {
          color: #FFFFFF;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .portrait-of-enterprises-item-title-img {
            width: 8px;
            height: 12px;
          }
          .portrait-of-enterprises-item-title-icon {
            width: 32px;
            font-size: 18px;
            padding: 0 0 5px 0;
          }
          .portrait-of-enterprises-item-title-info {
            font-size: 13px;
            margin-left: 5px;
          }
        }

        .device-operation-statistics-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 0;
          #deviceOnlineRate {
            width: 100px;
            height: 100px;
          }
          .device-operation-statistics-line-item {
            width: 100px;
            height: 60px;
            padding: 10px;
            .device-operation-statistics-line-item-tip {
              text-align: left;
              line-height: 15px;
              font-size: 12px;
            }
            .device-operation-statistics-line-item-info {
              display: flex;
              justify-content: flex-start;
              align-items: flex-end;
              text-align: left;
              line-height: 35px;
              .device-operation-statistics-line-item-number {
                font-size: 18px;
              }
              .device-operation-statistics-line-item-unit {
                font-size: 10px;
              }
            }
          }

          .device-operation-statistics-line-info {
            font-family: fantasy;
            font-size: 24px;
          }
          .device-operation-statistics-line-tip {
            font-size: 10px;
          }
          .device-operation-statistics-line-right {
            .device-operation-statistics-line-info {
              color: #fb140f;
            }
          }
        }

        .portrait-of-enterprises-right-strip-device-box {
          width: 100%;
          height: 280px;
          margin-bottom: 20px;
          .portrait-of-enterprises-right-strip-device-no-tip {
            height: 100%;
            padding: 10px 15px;
            text-align: center;
            color: #aaaaaa;
            font-size: 12px;
          }
          .portrait-of-enterprises-right-strip-device-list {
            height: 100%;
            padding: 10px 15px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            overflow-y: auto;
            .portrait-of-enterprises-right-strip-device-item {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              i {
                width: 50px;
                height: 40px;
                line-height: 40px;
                margin: 0 20px 0 0;
                font-size: 24px;
              }
              .portrait-of-enterprises-right-strip-device-item-info {
                flex: 1;
                .portrait-of-enterprises-right-strip-device-item-info-name {
                  font-size: 14px;
                  text-align: left;
                }
                .portrait-of-enterprises-right-strip-device-item-info-number {
                  font-size: 12px;
                  color: #aaaaaa;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }
              }
            }
          }
        }

        .device-operation-alar-line {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 0;
          .device-operation-alar-line-item {
            width: 100%;
            height: 60px;
            padding: 10px;
            .device-operation-alar-line-item-info {
              font-family: fantasy;
              font-size: 24px;
            }
            .device-operation-alar-line-item-name {
              font-size: 12px;
            }
          }
        }

        .alarm-record-table {
          height: 100%;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          text-align: center;
          font-size: 12px;
          padding: 10px 5px;
          .alarm-record-table-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #aaaaaa;
            padding: 10px 0;
          }
          .alarm-record-table-main {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            overflow-y: auto;
            .alarm-record-table-main-line {
              margin: 10px 0;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .alarm-record-table-main-no-tip {
              padding: 10px 15px;
              color: #aaaaaa;
            }
          }
        }

        .fireman-box {
          width: 100%;
          flex: 1;
          padding: 10px;
          margin: 10px auto;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .fireman-box-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .el-icon-damai-xiaofangyuan {
              font-size: 36px;
              background-image: -webkit-linear-gradient(
                bottom,
                red,
                #ff5f60,
                #f0c41b
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
            .fireman-box-line-name {
              text-align: left;
              margin-left: 5px;
              flex: 1;
            }
            .fireman-box-line-phone {
            }
          }
        }
      }
    }
  }

  .park-display-screen-alarm-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    background: url("../../../assets/upper/upper_page_bottom.png") no-repeat;
    background-size: 100% 100%;
  }
  .park-display-screen-alarm-bottom-basic-line {
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 77%;
    padding: 0 10px;
    height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    z-index: 99999;
    .park-display-screen-alarm-bottom-basic-line-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-right: 15px;
      .park-display-screen-alarm-bottom-basic-line-item-img {
        width: 50px;
        height: 50px;
      }
      .park-display-screen-alarm-bottom-basic-line-item-info {
        .park-display-screen-alarm-bottom-basic-line-item-amount {
        }
        .park-display-screen-alarm-bottom-basic-line-item-name {
          font-size: 12px;
          color: rgb(103, 224, 227);
        }
      }
    }
  }

  /deep/ .el-progress__text {
    color: #ffffff;
  }
  /deep/.el-timeline-item__wrapper {
    text-align: left;
  }
  /deep/.el-timeline-item__content {
    color: #ffffff;
  }
  /deep/.el-timeline-item__timestamp {
    color: #eeeeee;
  }
  /deep/.unit-label {
    display: none;
  }
  /deep/.unit-text {
    display: none;
  }
  /deep/.label-column > div:last-child {
    display: none;
  }

  #portraitEnterprisesItemRing::-webkit-scrollbar ,#parkHonorTimer::-webkit-scrollbar, #totalIntellectualProperty::-webkit-scrollbar {
    display: none;
    width: 0px;
    height: 0px;
  }
  #portraitEnterprisesItemRing .-o-scrollbar, #parkHonorTimer .-o-scrollbar, #totalIntellectualProperty .-o-scrollbar {
    width: 0px;
    height: 0px;
  }
  #portraitEnterprisesItemRing, #parkHonorTimer, #totalIntellectualProperty {
    -ms-scroll-chaining: chained;
    -ms-overflow-style: none;
    -ms-content-zooming: zoom;
    -ms-scroll-rails: none;
    -ms-content-zoom-limit-min: 100%;
    -ms-content-zoom-limit-max: 500%;
    -ms-scroll-snap-type: proximity;
    -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
    -ms-overflow-style: none;
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 1px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px #f9c986;
    background: #f9c986;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px #a26e26;
    border-radius: 5px;
    background: #a26e26;
  }


  .park-display-screen-alarm-mask {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: rgba(27, 148, 248, 0.3);
    z-index: 999999999;
    .park-display-screen-alarm-mask-main {
      width: 800px;
      height: 600px;
      background: #0F1F37;
      border-radius: 10px;
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin: 0 auto;
      transform: translateY(-50%);
      .park-display-screen-alarm-mask-main-title {
        width: 700px;
        height: 100px;
        line-height: 100px;
        margin: 0 auto;
      }
      .park-display-screen-alarm-mask-main-chart {
        width: 700px;
        height: 400px;
        margin: 0 auto;
      }
    }
  }
}

@keyframes warn {
  0% {
    -moz-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(1);
    transform: scale(1);
    opacity: 0;
  }
}

@keyframes warn1 {
  0% {
    -o-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -o-transform: scale(0.6);
    transform: scale(0.6);
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/ParkDisplayScreen/ParkDisplayScreenAlarm.vue